import { render } from "./AISettings.vue?vue&type=template&id=288cfcc2&scoped=true"
import script from "./AISettings.vue?vue&type=script&lang=js"
export * from "./AISettings.vue?vue&type=script&lang=js"

import "./AISettings.vue?vue&type=style&index=0&id=288cfcc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288cfcc2"]])

export default __exports__